import * as React from 'react';
import cx from 'classnames';
import px from 'prop-types';
import * as PRODUCT from '~config/product';
import { Product } from 'Common/types';
import { Carousel } from 'Common/components/ui';
import { CatalogCard } from '../catalog';
import { Formatter, Url } from 'Common/utils';
import { Translation } from 'Common/components/localization';
import { ProductInfo } from 'Common/models';

function priceProps(price) {
    const retail = [price.MinListPrice.Amount, price.MaxListPrice.Amount];
    const sale = [price.MinSalePrice.Amount, price.MaxSalePrice.Amount];
    const retailStr = retail ? Formatter.currency(retail, price.ListPrice.Currency) : '';
    const saleStr = sale ? Formatter.currency(sale, price.SalePrice.Currency) : '';

    if (!retail[1] && !sale[1]) return null;
    if ((retail[1] && !sale[1]) || retailStr === saleStr) return { price: retailStr };
    if (sale[1] && !retail[1]) return { price: saleStr };
    return { price: retailStr, reducedPrice: saleStr };
}

export default function ProductSlider({
    className,
    catalogEntities,
    checkoutPageLink = checkoutPageLink,
    isUserAuthenticated = isUserAuthenticated,
    openQuick,
}) {
    const carouselId = React.useId();

    // Custom carousel item component for catalog cards
    const CatalogCardItem = React.useCallback(({ item }) => (
        <CatalogCard
            code={item.Code}
            title={item.DisplayName}
            rating={item.Rating}
            reviewProviderEntityId={item.ReviewProviderEntityId}
            onSelectProduct={() => openQuick(item)}
            defaultImage={Url.addToRelativeUrl(
                item.DefaultImageUrl,
                `format=png&height=172&width=172${
                    PRODUCT.TRANSFORM_PRODUCT_IMAGE_BACKGROUND ? '&transBg=true' : ''
                }`
            )}
            productLinks={
                ProductInfo.isDisplayOnly(item)
                    ? []
                    : [
                          {
                              label: <Translation id="Commerce.CatalogNode.Card.QuickView" />,
                              key: 'quickViewLink',
                              icon: 'fas fa-eye',
                              action: () => {
                                  openQuick(item);
                              },
                          },
                      ]
            }
            marketingBadges={item.MarketingBadges}
            {...priceProps(item.Price)}
        />
    ), [openQuick]);

    if (!catalogEntities?.length) return null;

    return (
        <div className={cx('ProductSlider', className)}>
            <Carousel
                id={carouselId}
                items={catalogEntities}
                Item={CatalogCardItem}
                keyBy={(product) => product.Code}
                animateScroll
                itemWidth={220}
                gap={16}
                padding="3rem"
            />
        </div>
    );
}

ProductSlider.propTypes = {
    className: px.string,
    catalogEntities: px.arrayOf(Product),
    checkoutPageLink: px.string,
    isUserAuthenticated: px.oneOfType([px.string, px.bool]),
    openQuick: px.func,
};